import { Button, Dropdown } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import FolderIcon from "../../../../components/icons/FolderIcon";

const FolderCard = ({ folder, onFolderSelect, setSelectedRecord, user_id }) => {
  return (
    <>
      <div
        className="folder-item cursor-pointer"
        onClick={() => onFolderSelect(folder?.id)}
      >
        {user_id === folder?.created_by_user_id && (
          <Dropdown
            menu={{
              items: [
                {
                  key: "rename",
                  label: "Rename",
                  onClick: ({ domEvent }) => {
                    domEvent.stopPropagation();
                    setSelectedRecord(folder);
                  },
                },
                {
                  key: "delete",
                  label: "Delete",
                  onClick: ({ domEvent }) => {
                    domEvent.stopPropagation();
                    setSelectedRecord({ ...folder, isDelete: true });
                  },
                },
              ],
            }}
            trigger={["hover"]}
          >
            <Button
              className="more-option"
              type="text"
              icon={<MoreOutlined />}
            />
          </Dropdown>
        )}
        <FolderIcon />
        <div className="ellipsis-text name">{folder.name}</div>
        <div className="workbook-count">
          {folder?.workbooks?.length || 0} Items
        </div>
      </div>
    </>
  );
};

export default FolderCard;
